import { useState } from 'react'

const useLinkExpiredModal = initialShow => {
  const [showLinkExpiredModal, setShowLinkExpiredModal] = useState(initialShow)

  const closeLinkExpiredModal = () => setShowLinkExpiredModal(false)

  return { showLinkExpiredModal, closeLinkExpiredModal }
}

export default useLinkExpiredModal
